import { render } from "./StaffReports.vue?vue&type=template&id=3e6bb2c8&scoped=true"
import script from "./StaffReports.vue?vue&type=script&lang=js"
export * from "./StaffReports.vue?vue&type=script&lang=js"

import "./StaffReports.vue?vue&type=style&index=0&id=3e6bb2c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6bb2c8"]])

export default __exports__